import { useEffect } from 'react';
import { useGetDeckblattPDFMutation } from '../../api/AuftragAPI';

interface ThisProps {
  uidAuftrag: string;
}

/**
 * @author noone
 */
const AuftragDeckblattDownloadComponent: React.FC<ThisProps> = ({ uidAuftrag }) => {

  const [getDeckblattPDF] = useGetDeckblattPDFMutation();

  const deckblattPDF = async () => {

    await getDeckblattPDF(uidAuftrag).unwrap()
      .then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((e) => alert("" + e));
  }



  useEffect(() => {

  }, []);

  return (
    <>
      <button
        className="btn  btn-secondary"
        onClick={() => { { deckblattPDF(); } }} ><i className='bi bi-cloud-arrow-down'></i> Deckblatt</button>
    </>
  );

}

export default AuftragDeckblattDownloadComponent;